import React, { Component } from 'react';
import { buildPath } from '../utils/route_utils.js';
import '../css/Breadcrumb.css';

class Breadcrumb extends Component {
  render() {
    const { lang, items } = this.props;
    // items: [{ label: {zh, en, ja}, route: '/about/about_us' }, ...]
    // Last item has no route (current page)

    const homeLabel = { zh: "首頁", en: "Home", ja: "ホーム" };

    const allItems = [
      { label: homeLabel, route: '/' },
      ...(items || [])
    ];

    // JSON-LD BreadcrumbList
    const jsonLd = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": allItems.map((item, idx) => ({
        "@type": "ListItem",
        "position": idx + 1,
        "name": item.label[lang] || item.label.en,
        ...(item.route ? { "item": "https://www.nexuni.com" + buildPath(lang, item.route) } : {})
      }))
    };

    return (
      <>
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
        <nav className="breadcrumb_nav" aria-label="Breadcrumb">
          {allItems.map((item, idx) => (
            <span key={idx} className="breadcrumb_item">
              {idx > 0 && <span className="breadcrumb_sep">/</span>}
              {item.route ? (
                <a href={buildPath(lang, item.route)} className="breadcrumb_link">{item.label[lang]}</a>
              ) : (
                <span className="breadcrumb_current">{item.label[lang]}</span>
              )}
            </span>
          ))}
        </nav>
      </>
    );
  }
}

export default Breadcrumb;
